/**
 * Footer: brand name left, tagline right.
 */
export function Footer() {
  return (
    <footer className="border-t border-[#E2E8F0] bg-[#F7F8FA] px-6 py-8">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="font-[Bricolage_Grotesque] font-bold text-[#1A1A1A] text-lg tracking-tight">
          Verónica Aguilar
        </span>
        <p className="text-sm text-[#888888] font-[DM_Sans]">
          Designed and built with Claude by me while my cats walk around my desk &lt;3
        </p>
      </div>
    </footer>
  );
}
